import React from 'react';
import * as DateUtils from 'utils/dates';
import ActionsBlock from './ActionsBlock';
import * as CurrencyUtils from 'utils/currency';

const CONFIGURATION = {};

export default CONFIGURATION;

export const TableColumns = [
  {
    label: '#',
    id: 'payment_received_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Scheme Type',
    id: 'application_type',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'MSID Country',
    id: 'msid_country_code',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'Destination Country',
  //   id: 'mscon_country_code',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Message ID',
    id: 'message_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Payment Reference Number',
    id: 'payment_reference_number',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'Version',
  //   id: 'version',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Payment Date',
    id: 'payment_date_msid',
    align: 'center',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{DateUtils.formatDate(cellValue)}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Amount Received',
    id: 'grand_total_received',
    align: 'right',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        €{CurrencyUtils.formatCurrency(cellValue)}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Amount Transferred',
    id: 'grand_total_transferred',
    align: 'right',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        €{CurrencyUtils.formatCurrency(cellValue)}
      </React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'Account Name',
  //   id: 'account_name',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'BIC Code',
  //   id: 'bic_code',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'IBAN',
  //   id: 'iban_code',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'OBAN',
  //   id: 'oban_code',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'Submission Date',
  //   id: 'submission_date',
  //   align: 'left',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{DateUtils.formatDate(cellValue)}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'Is Allocated?', //This does not exist in the table
  //   id: 'is_allocated',
  //   align: 'center',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue === 1 ? 'Yes' : 'No'}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Actions',
    align: 'center',
    id: 'action1',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => (
      <ActionsBlock
        rowIndex={rowIndex}
        payment_received_id={data[rowIndex].payment_received_id}
        error={data[rowIndex].error}
        incoming_message_id={data[rowIndex].incoming_message_id}
        not_allocated_payments_count={data[rowIndex].not_allocated_payments}
      />
    ),
    inData: false,
  },
];

interface ITableDefaultFetchValues {
  TABLE_DEFAULT_PAGE: number;
  TABLE_DEFAULT_PAGE_SIZE: number;
  TABLE_DEFAULT_ORDER: 'desc' | 'asc';
  TABLE_DEFAULT_SORT_KEY: string;
}

export const PaymentsReceivedTableDefaultFetchValues: ITableDefaultFetchValues =
  {
    TABLE_DEFAULT_PAGE: 0,
    TABLE_DEFAULT_PAGE_SIZE: 25,
    TABLE_DEFAULT_ORDER: 'desc',
    TABLE_DEFAULT_SORT_KEY: TableColumns[0].id,
  };
